import { render, staticRenderFns } from "./TravelChart.vue?vue&type=template&id=c5052aa4"
import script from "./TravelChart.vue?vue&type=script&lang=js"
export * from "./TravelChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports